import React from 'react';
import { HStack, Divider, Text } from '@chakra-ui/react';

const DividerWithText = ({ text }) => (
  <HStack align="center" my={4}>
    <Divider />
    <Text color="gray.400" fontSize="sm" whiteSpace="nowrap">{text}</Text>
    <Divider />
  </HStack>
);

export default DividerWithText; 